export const modeTypes = {
    hole: 'hole',
    carousel: 'carousel'
};
